<template>
  <Drawer
    v-model="isFirstPageConfig"
    :mask-closable="false"
    :styles="styles"
    class-name="scmcc-First-Page-Config"
    @on-close="closeFirstPageConfig"
  >
  <div slot="header">
    <CIcon icon="tupianyulan-fankanqianyizhang" style="cursor:pointer" size="16" @click="closeFirstPageConfig"/>
    {{pagetitle}}
  </div>
    <div class="bottom-style">
      <div class="siderLeft" style="background-color:#fff;">
        <div class="title-style">基本信息</div>
        <Form
          :label-width="80"
          ref="homePageName"
          :rules="ruleValidate"
          :model="homePageName"
        >
          <FormItem label="布局名称" prop="homeName">
            <Input
              v-model="homePageName.homeName"
              placeholder="输入详情布局名称"
            />
          </FormItem>
        </Form>

        <div class="title-style">模块选择</div>
        <Collapse>
          <Panel>
            模块
            <Row slot="content">
              <draggable
                class="list-group"
                element="div"
                v-model="listLeft"
                @start="start"
                @end="end"
                :move="onMove"
                :options="dragOptions1"
              >
                <div
                  is="Col"
                  v-for="(item, key) in listLeft"
                  :key="key"
                  :class="['list-item', { 'item-drag': !inRight(item) }]"
                >
                  <div class="dragItem">
                    <CIcon :icon="item.src" size="30" />
                    <div class="dragname-style">{{ item.name }}</div>
                  </div>
                </div>
              </draggable>
            </Row>
          </Panel>
        </Collapse>
      </div>

      <!--拖拉区域展示-->
      <div class="siderRight">
        <div class="itemWrapper">
          <component :is="'HelloComponent'" ref="hello"></component>
        </div>
        <div
          class="tipSelectstyle"
          v-show="!startDarg && listRight.length == 0"
        >
          <span class="tipSelectContent">请从左侧选择功能模块</span>
        </div>
        <draggable
          class="itemGroupTop"
          element="div"
          v-model="listRight"
          :options="dragOptions2"
        >
          <Row v-for="(item, key) in listRight" :key="key">
            <div is="Col">
              <div class="itemWrapper">
                <Icon
                  class="removeIcon"
                  type="md-close"
                  @click="removeItem(listRight, key)"
                />
                <!-- <component :is="getComponent(item)" ></component> -->
                <component
                  :is="item.targetComponent"
                  can-edit
                  v-model="item.config"
                ></component>
              </div>
            </div>
          </Row>
        </draggable>
      </div>
    </div>
    <div ref="commonCustomTable"></div>
    <div class="demo-drawer-footer">
      <Button style="margin-right: 8px" @click="closeFirstPageConfig()"
        >取消</Button
      >
      <Button type="primary" @click="submit('homePageName')">保存</Button>
    </div>
  </Drawer>
</template>

<script>
import { validategllength2And10 } from '@/assets/utils'
import draggable from 'vuedraggable'
import HelloComponent from '@/views/settings/HelloComponent'
import { constants } from 'fs'
export default {
  name: 'App',
  components: {
    draggable,
    HelloComponent
  },
  data() {
    return {
      startDarg: false,
      homePageName: {
        homeName: ''
      },
      moduleIds: [],
      homePageId: '',
      isAdd: true,
      isFirstPageConfig: false,
      pagetitle: '',
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },

      listLeft: [
        {
          name: '我的待办',
          value: '0',
          targetComponent: 'scmd-home-todolistComponent',
          config: '',
          src: 'shouye-wodedaiban'
        },
        {
          name: '消息',
          value: '1',
          targetComponent: 'scbf-home-messageManager',
          config: '',
          src: 'shouye_xiaoxi'
        },
        {
          name: '客户',
          value: '3',
          targetComponent: 'sccm-home-component',
          config: '',
          src: 'shouye-kehu'
        },
        {
          name: '知识库',
          value: '1',
          targetComponent: 'sckm-home-component',
          config: '',
          src: 'shouye_zhishiku'
        },
        {
          name: '外拨',
          value: '2',
          targetComponent: 'scocm-home-taskManager',
          config: '',
          src: 'shouye-waibo'
        },
        {
          name: '联系计划',
          value: '3',
          targetComponent: 'scocm-home-contactPlan',
          config: '',
          src: 'shouye-lianxijihua'
        }
      ],
      listRight: [],
      ruleValidate: {
        homeName: [
          { required: true, message: '请填写首页名', trigger: 'blur' },
          { validator: validategllength2And10, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    let modules = this.$store.state.main.user.modules
    this.listLeft = this.listLeft.filter(item => {
      let targetComponent = item.targetComponent
      let targetComponentName = targetComponent.split('-')[0]+'_ui'
      if(targetComponentName == 'scmd_ui'){
        if(modules['scwf_ui']){
          return true
        }else{
          return false
        }
      }
      if(modules[targetComponentName]){
        return true
      }else{
        return false
      }
    })
  },
  computed: {
    dragOptions1() {
      return {
        animation: 150,
        group: {
          name: 'description',
          pull: 'clone',
          put: false
        },
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        sort: false,
        draggable: '.item-drag',
        showDropzoneAreas: true
      }
    },
    dragOptions2() {
      return {
        animation: 150,
        group: 'description',
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        sort: true,
        dropzoneSelector: 'ul',
        draggableSelector: 'li',
        showDropzoneAreas: true
      }
    },
    pageMessage: {}
  },
  methods: {
    start() {
      this.startDarg = true
      console.log('this.startDarg', this.startDarg, this.listRight)
    },
    end() {
      this.startDarg = false
      console.log('this.startDarg', this.startDarg, this.listRight)
    },
    inRight(item) {
      return this.listRight.indexOf(item) !== -1
    },
    openFirstPageConfig(AddSign, data1, data2, data3) {
      this.homePageId = data1
      this.moduleIds = data2
      this.homePageName.homeName = data3
      console.log('moduleIds', AddSign, this.moduleIds)
      this.isAdd = AddSign
      this.pagetitle = AddSign ? '新建自定义首页布局' : '编辑自定义首页布局'
      console.log('this.moduleIds', this.moduleIds)
      //从moduleIds拿到各个模块的数据，并分给各个模块
      if (this.moduleIds) {
        JSON.parse(this.moduleIds).forEach(item => {
          let moduleitem = this.listLeft.find(
            _ => _.targetComponent === item.name
          )
          console.log('moduleitem', moduleitem)
          if (moduleitem !== undefined) {
            moduleitem.config = item.config
            console.log('333')
            this.listRight.push(moduleitem)
          }
        })
        console.log('this.listRight', this.listRight)
      }

      // let sckm = this.listLeft.find(_ => _.targetComponent === 'sckm-Home-component')
      // sckm.config = JSON.stringify({
      //   show_content: ["2","3"]
      // })
      // this.listRight = [sckm]

      this.isFirstPageConfig = true
    },
    closeFirstPageConfig() {
      this.isFirstPageConfig = false
      console.log('this.isFirstPageConfig', this.isFirstPageConfig)
      this.listRight = []
    },
    removeItem(itemList, index) {
      console.log('44444itemList', itemList)
      itemList.splice(index, 1)
    },
    submit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let moduleIds = this.listRight.map(_ => ({
            name: _.targetComponent,
            config: _.config
          }))
          let addMessage = {}
          addMessage.indexName = this.homePageName.homeName
          addMessage.moduleIds = JSON.stringify(moduleIds)
          //如果是新增，调新增接口
          if (this.isAdd) {
            this.$http
              .post('/sctm/customindex/saveCustomIndex', addMessage)
              .then(res => {
                if (res.data.returnCode == 0) {
                  this.closeFirstPageConfig()
                  this.$parent.queryFirstPageList()
                } else {
                  this.$Message.error(res.data.returnMessage)
                }
              })
          } else {
            //调更新接口
            let updateMessage = {}
            updateMessage.id = this.homePageId
            updateMessage.indexName = this.homePageName.homeName
            updateMessage.moduleIds = JSON.stringify(moduleIds)
            this.$http
              .post('/sctm/customindex/updateCustomIndex', updateMessage)
              .then(res => {
                if (res.data.returnCode == 0) {
                  this.closeFirstPageConfig()
                  this.$parent.queryFirstPageList()
                } else {
                  this.$Message.error(res.data.returnMessage)
                }
              })
          }
        }
      })
    }
  }
}
</script>

<style lang="less">
.scmcc-First-Page-Config {
  .demo-drawer-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }
  .ivu-drawer {
    width: 100%!important;
  }
  .ivu-drawer-header {
    font-size: 18px;
    position: relative;
    // height: 65px;
  }
  .ivu-drawer-close .ivu-icon-ios-close {
    height: 32px;
    line-height: 32px;
  }
  .ivu-drawer-body {
    padding: 0;
  }
  .ivu-drawer-header-inner {
    font-size: 18px;
    color: #5e5f77;
    font-weight: 700;
    height: 32px;
    line-height: 32px;
  }
  .ivu-form .ivu-form-item-label {
    text-align: left;
  }

  .bottom-style {
    display: flex;
    height: 100%;
    .siderLeft {
      max-width: 430px;
      overflow-y: auto;
      padding: 0 36px 24px;
      height: calc(100% - 24px);
      .ivu-form .ivu-form-item-label {
        width: 68px;
        font-size: 14px;
        color: #33344a;
      }
      .list-item:not(.item-drag) .dragItem {
        position: relative;
        &:before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background-color: rgba(255, 255, 255, 0.7);
        }
      }
      .ivu-icon {
        position: absolute;
        right: 0px;
        top: 35%;
      }
      .ivu-collapse-header {
        background-color: #ffffff;
        color: #04cbd8;
      }
      .title-style {
        font-size: 16px;
        color: #33344a;
        margin-top: 25px;
        margin-bottom: 27px;
        font-weight: 600;
      }
      .ivu-layout-sider-children {
        background-color: #ffffff;
      }
      .ivu-collapse-content {
        background-color: rgb(241, 245, 252);
        padding: 0;
        .ivu-collapse-content-box {
          padding: 0;
        }
      }
      .list-group {
        overflow: hidden;
        margin-bottom: 3%;
        width: 100%;
        .dragItem {
          border: 1px solid #d9e1f6;
          border-radius: 4px;
          float: left;
          margin-top: 3%;
          margin-left: 2.5%;
          width: 30%;
          background-color: #fff;
          padding: 2%;
          .dragname-style {
            margin-top: 5%;
          }
        }
        .ivu-col {
          text-align: center;
        }
      }
    }
    .siderRight {
      background-color: rgb(240, 241, 247);
      height: calc(100% - 24px);
      overflow-y: auto;
      margin-left: 5px;
      display: flex;
      flex: 1;
      flex-direction: column;
      padding: 16px;
      overflow-y: scroll;
      .itemWrapper {
        display: block;
        /* border: 1px solid gray; */
        margin-bottom: 16px;
        position: relative;
        transition: all 0.2s ease-in-out;
        border-radius: 6px;
      }
      .tipSelectstyle {
        background-color: #ffff;
        height: 100%;
        border-radius: 6px;
        text-align: center;
        .tipSelectContent {
          line-height: 162px;
          font-size: 16px;
          color: #9999a4;
        }
      }
      .itemGroupTop {
        min-height: calc(100% - 200px);
        background-color: rgb(240, 241, 247);
        .itemWrapper {
          display: block;
          /* border: 1px solid gray; */
          position: relative;
          transition: all 0.2s ease-in-out;
          border-radius: 6px;
          margin-bottom: 16px;
          .removeIcon {
            position: absolute;
            right: -6px;
            top: -6px;
            font-size: 12px;
            color: #fff;
            background: #f00;
            padding: 1px;
            border-radius: 50%;
            z-index: 9;
            cursor: pointer;
          }
          &:not(:hover) .removeIcon {
            display: none;
          }
          &:hover {
            box-shadow: 0 0 4px 0 #458bf5, 0 0 16px 0 rgba(69, 139, 245, 0.4);
          }
        }
      }
    }
  }
}
</style>